import { Icon } from "icons";
import { type ComponentProps } from "react";

import {
  type AthleteProduct,
  getAthleteProductTone,
} from "src/helpers/athleteProductState";

import { StatusBadge } from "./StatusBadge";

interface AthleteProductBadgeProps extends ComponentProps<"span"> {
  product: AthleteProduct;
}

export function AthleteProductBadge(props: AthleteProductBadgeProps) {
  const { product, ...rest } = props;

  return (
    <StatusBadge
      {...rest}
      tone={getAthleteProductTone(product)}
      icon={
        product.subscriptionStatus === null ? (
          <Icon name="tabler-circle-number-1" className="size-3.5 shrink-0" />
        ) : null
      }
      className="max-w-48"
    >
      <span className="truncate">{product.name}</span>
    </StatusBadge>
  );
}
